var map = {
	"./about.vue": [
		"7dd8",
		"chunk-57a288ba"
	],
	"./co.vue": [
		"185d",
		"chunk-0fa645b8"
	],
	"./contact.vue": [
		"5d8b",
		"chunk-730460e6"
	],
	"./hardware.vue": [
		"90ae",
		"chunk-fd640096"
	],
	"./home.vue": [
		"eea6",
		"chunk-6fe8c8f8"
	],
	"./medical.vue": [
		"155f",
		"chunk-409319ca"
	],
	"./news.vue": [
		"6078",
		"chunk-55b04a62"
	],
	"./newsDetail.vue": [
		"e77c",
		"chunk-3ab6fe3e"
	],
	"./people.vue": [
		"65f2",
		"chunk-843f5516"
	],
	"./product.vue": [
		"2320",
		"chunk-4a995336"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;